module.exports = __webpack_public_path__ + "static/media/plier-two.6c821688.png";